import { type RichiestaPubblicaDtoRichiesta } from '@framework/api-client/api/inquiries-compile/schemas/richiestaPubblicaDtoRichiesta.ts';
import { SubmissionLogic } from '@framework/frontoffice-submission/submission/SubmissionLogic.ts';
import { VerticalSpace } from '@framework/ui/components/space/VerticalSpace.tsx';
import { DividerTitleElement } from '@framework/ui/components/text/DividerTitleElement.tsx';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { DescriptionItem } from './DescriptionItem.tsx';

export interface ISubmissionDataViewProps {
  submission?: RichiestaPubblicaDtoRichiesta;
}

/**
 * ...
 */
export function SubmissionDataView(props: ISubmissionDataViewProps) {
  const { submission } = props;
  const { t } = useTranslation();

  if (!submission) return null;

  const applicants = SubmissionLogic.getApplicant(submission);

  return (
    <div>
      <DividerTitleElement
        title={t(
          'observation-details.dati-della-richiesta',
          'Dati della Richiesta',
        )}
        removeTopMargin
      />
      <Row>
        <Col span={12}>
          <DescriptionItem
            label={t('observation-details.domanda', 'Domanda')}
            value={submission?.titoloTipoDomanda ?? '-'}
          />
        </Col>
        <Col span={6}>
          <DescriptionItem
            label={t('observation-details.numero-istanza', 'Numero Istanza')}
            value={submission?.progressivo ?? '-'}
          />
        </Col>
        {applicants && (
          <Col span={6}>
            <DescriptionItem
              label={t('observation-details.titolare', 'Titolare')}
              value={applicants.mainOwner ?? '-'}
            />
          </Col>
        )}
      </Row>
      <VerticalSpace size={12} />
      {applicants?.multipleApplicants && (
        <Row>
          <Col span={24}>
            <DescriptionItem
              label={t('observation-details.altri-titolari', 'Altri Titolari')}
              value={applicants.others?.join(', ') ?? '–'}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}
